export const validateNotUnknown = <T>(input: T) =>
	input !== 'Unknown' ? input : null;
